var map = {
	"./1.png": 87998,
	"./10.png": 53116,
	"./2.png": 55349,
	"./3.png": 86252,
	"./4.png": 16419,
	"./5.png": 98842,
	"./6.png": 29009,
	"./7.png": 14792,
	"./8.png": 97055,
	"./9.png": 17078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73175;